import React from 'react'
import { ParkedVehicle } from '../../lib/supabase'

interface ParkedVehicleCardProps {
  parkedVehicle: ParkedVehicle
  parkingDuration: string
  onNavigate: () => void
  onStop: () => void
  t: (key: string) => string
}

export function ParkedVehicleCard({ parkedVehicle, parkingDuration, onNavigate, onStop, t }: ParkedVehicleCardProps) {
  return (
    <div className="bg-white/95 backdrop-blur-xl rounded-[2rem] shadow-2xl p-5 sm:p-6 border border-white/20 ring-1 ring-black/5 mb-4">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center space-x-3 sm:space-x-4 overflow-hidden">
          <div className="flex-shrink-0 w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-[11px] font-black text-slate-400 uppercase tracking-widest mb-0.5">{t('dashboard.parkedAt')}</h3>
            <p className="text-[16px] sm:text-[17px] font-black text-slate-800 leading-tight truncate">{parkedVehicle.address || 'Location'}</p>
          </div>
        </div>
      </div>
      
      <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 mb-5 flex items-center justify-between">
         <span className="text-[13px] font-bold text-slate-500 uppercase tracking-wider">Durée</span>
         <span className="font-mono text-2xl font-black text-emerald-600 tracking-tight">{parkingDuration}</span>
      </div>
      
      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={onNavigate}
          className="flex items-center justify-center px-4 py-3.5 bg-emerald-500 text-white rounded-2xl hover:bg-emerald-600 transition-all font-black text-[14px] sm:text-[15px] shadow-lg shadow-emerald-500/30 active:scale-[0.98]"
        >
          {t('dashboard.navigateToVehicle')}
        </button>
        <button
          onClick={onStop}
          className="flex items-center justify-center px-4 py-3.5 bg-white text-red-500 rounded-2xl hover:bg-red-50 transition-all border-2 border-red-100 font-black text-[14px] sm:text-[15px] active:scale-[0.98]"
        >
          {t('dashboard.stopParking')}
        </button>
      </div>
    </div>
  )
}
